import React from 'react';
import Select from './select';
import Text from './text';

class Combobox extends React.Component {
  state = {
    value: {
      select: null,
      text: '',
    },
    mounted: false,
  };

  componentDidMount() {
    const { value } = this.props;
    // console.log(value, 'value on mount');
    const newState = {
      ...this.state,
      mounted: true,
    }
    if (value) {
      newState.value = {
        select: value.select || null,
        text: value.text || '',
      };
    }
    this.setState(newState);
  }

  updateParent = (value) => {
    this.props.updateValue({ target: { value: value, name: this.props.name } });
  }

  handleSelectChange = (event) => {
    // console.log(event, 'select');
    const newState = {
      ...this.state,
      value: {
        ...this.state.value,
        select: event.target.value,
      },
    };
    this.setState(newState);
    this.updateParent(newState.value);
    // this.props.updateValue(state.value);
  }
  handleTextChange = (event) => {
    // console.log(event, 'text');
    const newState = {
      ...this.state,
      value: {
        ...this.state.value,
        text: event.target.value,
      },
    };
    this.setState(newState);
    this.updateParent(newState.value);
  }

  render() {
    // Pause for a split second to ensure mounting logic has run (to allow defaults to get passed down)
    if (!this.state.mounted) {
      return null;
    }
    const { field, name, submitting } = this.props;
    // console.log(field, 'the field');
    if (!field || !field.options || !field.options.length) {
      return null;
    }

    return (
      <div className="relative flex">
        <div className="w-1/2 pr-1">
          <Select
            field={field}
            updateValue={this.handleSelectChange}
            name={`${name}_select`}
            submitting={submitting}
            value={this.state.value.select}
          />
        </div>
        <div className="w-1/2">
          <Text
            field={field}
            name={`${name}_text`}
            submitting={submitting}
            updateValue={this.handleTextChange}
            value={this.state.value.text}
          />
        </div>
      </div>
    );
  }
};

export default Combobox;